import { unstable_isMuiElement as isMuiElement } from '@material-ui/utils';
export default isMuiElement;